var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"plv-pc-redpack-rain",staticClass:"plv-pc-redpack-rain"},[_c('redpack-rain-comp',{ref:"redpackRain",attrs:{"redpack-rain":_vm.redpackRainSdk,"lang":_vm.lang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }